import { type RefObject, useEffect, useRef } from 'react'

/**
 * ref 요소 바깥을 클릭하면 콜백을 실행한다.
 * `useClickOutside` 와 달리 ref 포함 검사를 하므로 popover 내부의
 * 인터랙티브 요소(DatePicker 등) 클릭으로는 닫히지 않는다.
 */
export const useOnClickOutside = (
  ref: RefObject<HTMLElement>,
  onClickOutside: () => void,
  enabled = true,
) => {
  // 인라인 콜백이 렌더마다 바뀌어도 listener 를 재등록하지 않도록 최신 콜백만 보관
  const callbackRef = useRef(onClickOutside)
  callbackRef.current = onClickOutside

  useEffect(() => {
    if (!enabled) return
    const handler = (e: MouseEvent) => {
      if (!ref.current?.contains(e.target as Node)) {
        callbackRef.current()
      }
    }
    // 다음 tick 에 등록 (현재 클릭으로 인한 즉시 닫힘 방지)
    const timer = setTimeout(() => document.addEventListener('mousedown', handler), 0)
    return () => {
      clearTimeout(timer)
      document.removeEventListener('mousedown', handler)
    }
  }, [enabled, ref])
}
